import { useCallback } from "react";
import { useBrand } from "@/contexts/cdpConfig";
import { IS_SERVER, NOOP } from "@/constants";
import { useBrandUrl } from "./useBrandUrl";
import { useBrowserAPI } from "./useBrowserAPI";
export const useBackNavigation = () => {
    const brandId = useBrand();
    const baseUrl = useBrandUrl();
    const { bWindow } = useBrowserAPI();
    return useCallback(() => {
        if (IS_SERVER)
            return NOOP;
        const { referrer } = bWindow.document;
        const currentUrl = new URL(bWindow.location.href);
        const serpView = currentUrl.searchParams.get("serp_view");
        const classifiedSearch = serpView === "map" ? "/classified-map?" : "/classified-search?";
        const search = currentUrl.searchParams.get("search");
        const url = `${baseUrl}${classifiedSearch}${search}`;
        if (referrer.includes(brandId) && bWindow.history.length > 1) {
            bWindow.history.back();
        }
        else if (search) {
            bWindow.location.href = url;
        }
        else {
            bWindow.location.href = baseUrl;
        }
    }, [baseUrl, brandId, bWindow]);
};
